var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasicPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4515",
    filter: "url(#filter0_d_1_275)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 39,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 45,
    r: 38.5,
    stroke: "#5B73E8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "an"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.9411 57.5894C41.0687 57.5894 40.2564 57.1981 39.7126 56.5161L37.8036 54.1224L36.124 53.3135L31.7388 62.1334C31.519 62.5757 31.5438 63.1003 31.8044 63.5199C32.0644 63.9385 32.5223 64.1931 33.015 64.1931H33.0182L37.0858 64.1839L39.5336 67.4325C39.8043 67.7917 40.2268 68.0001 40.6716 68C40.7153 68 40.7591 67.998 40.803 67.9939C41.2949 67.9484 41.7281 67.6515 41.948 67.2093L46.397 58.2608L45.0028 57.5894H41.9411Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.2627 62.1334L61.8776 53.3135L60.198 54.1224L58.289 56.5162C57.7452 57.1981 56.9329 57.5894 56.0605 57.5894H52.9987L51.6045 58.2608L56.0535 67.2093C56.2734 67.6515 56.7067 67.9484 57.1985 67.9939C57.2424 67.9979 57.2862 68 57.3299 68C57.7746 68 58.1972 67.7917 58.4679 67.4325L60.9157 64.1839L64.9833 64.1931H64.9865C65.4792 64.1931 65.9371 63.9386 66.1971 63.5199C66.4577 63.1003 66.4826 62.5757 66.2627 62.1334Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M56.0584 56.1635C56.4921 56.1635 56.9023 55.966 57.1727 55.6269L59.2845 52.9788L62.3361 51.5092C62.7269 51.3209 63.0107 50.9651 63.1073 50.5423L63.861 47.24L65.9728 44.5919C66.2433 44.2528 66.3445 43.809 66.248 43.3862L65.4943 40.0841L66.248 36.7819C66.3444 36.3589 66.2433 35.9153 65.9728 35.5761L63.861 32.928L63.1073 29.6258C63.0108 29.203 62.7269 28.8471 62.3361 28.6589L59.2845 27.1893L57.1727 24.5411C56.9022 24.202 56.4921 24.0046 56.0584 24.0046H52.6713L49.6196 22.5348C49.2287 22.3466 48.7737 22.3466 48.3828 22.5348L45.3312 24.0044H41.9441C41.5104 24.0044 41.1002 24.2019 40.8298 24.541L38.718 27.1891L35.6664 28.6587C35.2756 28.8469 34.9918 29.2028 34.8952 29.6256L34.1415 32.9278L32.0297 35.5759C31.7592 35.915 31.658 36.3588 31.7545 36.7817L32.5082 40.0839L31.7545 43.386C31.6581 43.8089 31.7592 44.2526 32.0297 44.5917L34.1415 47.2399L34.8952 50.5421C34.9917 50.9649 35.2756 51.3208 35.6664 51.509L38.718 52.9786L40.8298 55.6267C41.1003 55.9658 41.5104 56.1633 41.9441 56.1633H45.3312L48.3828 57.6329C48.5782 57.727 48.7897 57.774 49.0012 57.774C49.2126 57.774 49.4242 57.727 49.6195 57.6329L52.6712 56.1633H56.0583L56.0584 56.1635ZM49.0012 52.5542C42.1251 52.5542 36.531 46.9601 36.531 40.084C36.531 33.2079 42.1251 27.6137 49.0012 27.6137C55.8773 27.6137 61.4715 33.2079 61.4715 40.084C61.4715 46.9601 55.8773 52.5542 49.0012 52.5542Z",
    fill: "#27B783"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M48.9972 29.0389C42.9069 29.0389 37.9521 33.9937 37.9521 40.084C37.9521 46.1743 42.9069 51.1291 48.9972 51.1291C55.0875 51.1291 60.0423 46.1743 60.0423 40.084C60.0423 33.9937 55.0875 29.0389 48.9972 29.0389ZM49.2923 43.3539C49.0157 43.6306 48.6507 43.7714 48.2843 43.7714C47.9707 43.7714 47.6559 43.6683 47.3944 43.4591L43.8314 40.6088L45.612 38.3831L48.1788 40.4366L52.265 36.3504L54.2804 38.3659L49.2923 43.354V43.3539Z",
    fill: "#27B783"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_275",
    x: 0,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_275",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasicPlan);
export default __webpack_public_path__ + "static/media/basicPlan.08bf0c25d676718672d99a6682f5f8a3.svg";
export { ForwardRef as ReactComponent };